import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.map.js";
import Form from "../../Form";
import Pagination from "../../models/pagination/Pagination";
export default class PaginationForm extends Form {
  constructor(options = {}) {
    super();
    _defineProperty(this, "currentPage", {
      modelKey: Pagination.getCurrentPageAttributeName(),
      fieldName: 'current_page',
      content: 1,
      setContent(content) {
        this.content = content;
      }
    });
    _defineProperty(this, "data", {
      modelKey: Pagination.getDataAttributeName(),
      fieldName: 'data',
      content: [],
      setContent(content) {
        this.content = content;
      }
    });
    _defineProperty(this, "perPage", {
      modelKey: Pagination.getPerPageAttributeName(),
      fieldName: 'per_page',
      content: 5,
      default: 5,
      options: PaginationForm.BY_FIVE_PAGINATION_LIST,
      setContent(content) {
        this.content = content;
      }
    });
    _defineProperty(this, "total", {
      modelKey: Pagination.getTotalAttributeName(),
      fieldName: 'total',
      content: 0,
      setContent(content) {
        this.content = content;
      }
    });
    let {
      perPage = null,
      perPageOptions = null
    } = options;
    this.perPage.options = Array.isArray(perPageOptions) ? perPageOptions : PaginationForm.BY_FIVE_PAGINATION_LIST;
    this.perPage.content = this.perPage.default = perPage !== null && perPage !== void 0 ? perPage : this.perPage.options[0].value;
  }
  resetPage() {
    this.currentPage.content = 0;
  }
  startLoading() {
    this.loading.list = true;
    return this;
  }
  isLoading() {
    return this.loading.list;
  }
  endLoading() {
    this.loading.list = false;
    return this;
  }
  getItemsPerPage() {
    return this.perPage.content;
  }
  getPerPageOptions() {
    var _this$perPage$options;
    return (_this$perPage$options = this.perPage.options) !== null && _this$perPage$options !== void 0 ? _this$perPage$options : [];
  }
  getSelectedItemsPerPage() {
    let itemsPerPage = this.getItemsPerPage();
    if (this.perPage.options.map(o => o.value).includes(itemsPerPage)) return itemsPerPage;
    return -1;
  }
  getCurrentPage() {
    return this.totalPages() >= this.currentPage.content ? this.currentPage.content : 1;
  }
  totalPages() {
    return this.getItemsPerPage() > 0 && this.getTotalItems() > 0 ? Math.ceil(this.getTotalItems() / this.getItemsPerPage()) : 1;
  }
  setCurrentPage(currentPage) {
    return this.currentPage.content = currentPage;
  }
  getTotalItems() {
    var _this$total$content;
    return (_this$total$content = this.total.content) !== null && _this$total$content !== void 0 ? _this$total$content : 0;
  }
  isEmpty() {
    return this.getTotalItems() < 1;
  }
  setItemsPerPage(itemsPerPage) {
    this.perPage.content = itemsPerPage;
    return this;
  }
  setTotalItems(totalItems) {
    this.total.content = totalItems;
    return this;
  }
  getQuery(page = null, perPage = null, withInterrogationMark = true) {
    var _page;
    page = (_page = page) !== null && _page !== void 0 ? _page : this.getCurrentPage();
    page = !page ? 1 : page;
    return `${withInterrogationMark ? '?' : ''}show=${perPage !== null && perPage !== void 0 ? perPage : this.getItemsPerPage()}&page=${page}`;
  }
  getQueryObject(args) {
    var _page2;
    let {
      perPage = null,
      page = null
    } = args !== null && args !== void 0 ? args : {};
    page = (_page2 = page) !== null && _page2 !== void 0 ? _page2 : this.getCurrentPage();
    page = page ? page : 1;
    return {
      show: perPage !== null && perPage !== void 0 ? perPage : this.getItemsPerPage(),
      page
    };
  }
  getPaginatedData() {
    var _this$data$content;
    return (_this$data$content = this.data.content) !== null && _this$data$content !== void 0 ? _this$data$content : [];
  }
  setPaginatedData(data) {
    this.data.content = data;
    return this;
  }
  pageHasItems() {
    return this.getPaginatedData().length > 0;
  }
  hasItemsThenItemsPerPage() {
    return this.getTotalItems() > this.getItemsPerPage();
  }
  setPerPageItems(perPage) {
    this.perPage.content = perPage;
  }
}
_defineProperty(PaginationForm, "BY_FIVE_PAGINATION_LIST", [{
  text: '5',
  value: 5
}, {
  text: '10',
  value: 10
}, {
  text: '15',
  value: 15
}, {
  text: 'pagination.all',
  value: -1
}]);
_defineProperty(PaginationForm, "BY_TWELVE_PAGINATION_LIST", [{
  text: '12',
  value: 12
}, {
  text: '24',
  value: 24
}, {
  text: '36',
  value: 36
}, {
  text: 'pagination.all',
  value: -1
}]);